<div class="block" style="margin-top: 2%; margin-bottom: 0" *ngIf="batchTransactions && batchTransactions.length>0">
  <div class="batch-data-block">
    <div *ngFor="let item of batchTransactionsList; let i = index">
      <p class="batchdata"
         (click)="getBatchEntryDetailsByBatchNumber(item.id, item.date_time)"><span>{{item.batch_number}}</span>
        <span
          style="margin-left: 20px;">Batch Date(Time): {{((item.createdAt.split('T')[0])| date)}} {{convertTo24Hrs(item.date_time)}}</span>
        <span style="margin-left: 20px; float: right">Treatment Date: {{((item.date_time.split('T')[0])| date)}}</span>
      </p>
    </div>
    <div *ngIf="listLoader" class="loader-div">
      <div class="adjust">
        <div class="loader2 list-loader"></div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="myModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <!--<span class="meal-tank" *ngFor="let child of batchDetails"> {{child.tank_name}}  </span>-->
        </div>
        <div *ngIf="selectedBatchTimeStamp" class="time-stamp-div">
          <span
            class="time-stamp-span">Treatment Date: {{((selectedBatchTimeStamp.split('T')[0])| date)}}</span>
        </div>
        <div class="modal-body batch-details-popup">
          <div class="row treatlist" [ngClass]="{'treatlist' : treatmentLogsData && treatmentLogsData.length>2 }">
            <div class="row mealcard" *ngFor="let meal of treatmentLogsData">
              <p class="meal-tank">Tank: {{meal && meal.Ponds && meal.Ponds.name}}</p>
              <table class="table table-bordered table-striped text-center table-responsive">
                <thead>
                <tr>
                  <th>S.No</th>
                  <th>Treatment</th>
                  <th>Quantity</th>
                  <th>UOM</th>
                  <th>Treatment Type</th>
                  <th width="10%">Description</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of meal.treatmentLogs; let i = index;">
                  <td>{{i + 1}}</td>
                  <td>{{item.itemMaster.item_name}}<span
                    *ngIf="item && item.itemMaster.sub_type">-</span> {{item && item.itemMaster.sub_type}}</td>
                  <td>{{item.quantity }}</td>
                  <td>{{item.uom}}</td>
                  <td>{{item && item.treatmentType && item.treatmentType.name}}</td>
                  <td>{{(item && item.description == '0') ? 'NA' : item && item.description}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
